import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { withLatestFrom, map, concatMap } from 'rxjs/operators';
import { Action } from 'redux';
import AppState from '../../state';
import { CREATE_RELEASE_SUCCESS } from '../../release/actions';
import { CREATE_TRACK, REMOVE_TRACK } from '../../tracks/actions';
import { trackList } from '@webapp/store/tracks/selectors';
import { UpdateField } from '../action-creators';
import { UpdateTrackField } from '@webapp/store/tracks/action-creators';

/**
 *
 * This effect updates the release type after a track is created
 *
 */

export const updateReleaseType = (
  action$: Observable<Action>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Action>(CREATE_RELEASE_SUCCESS, CREATE_TRACK, REMOVE_TRACK),
    withLatestFrom(state$),
    map(([_, state]) => {
      const tracks = trackList(state.tracks.tracks, state.release.release?.id);
      const actions: Action[] = [
        new UpdateField<'type'>('type', tracks.length > 1 ? 'album' : 'single'),
      ];

      if (
        tracks.length === 1 &&
        tracks[0].id &&
        state.release.release?.id &&
        state.release.release?.title
      ) {
        actions.push(
          new UpdateTrackField(
            tracks[0].id,
            'title',
            state.release.release?.title
          )
        );
      }

      return actions;
    }),
    concatMap((actions) => actions)
  );
